import React from 'react';
import { MessageSquare, FileSearch, DollarSign, CheckCircle } from 'lucide-react';

const ProcessSteps = () => {
  const steps = [
    {
      icon: MessageSquare,
      step: '1',
      title: 'Jūsų užklausa',
      description: 'Susisiekite su mumis telefonu, el. paštu arba užpildykite kontaktų formą'
    },
    {
      icon: FileSearch,
      step: '2',
      title: 'Poreikių analizė ir sprendimas',
      description: 'Išanalizuojame jūsų poreikius ir pasiūlome optimaliausią sprendimą'
    },
    {
      icon: DollarSign,
      step: '3',
      title: 'Aiškus pasiūlymas ir įkainiai',
      description: 'Gaunate detalų pasiūlymą su skaidriais ir suprantamais įkainiais'
    },
    {
      icon: CheckCircle,
      step: '4',
      title: 'Sklandus startas ir nuolatinės ataskaitos',
      description: 'Pradėdame bendradarbiavimą ir teikiame reguliarias ataskaitas'
    },
  ];

  return (
    <section className="py-16 bg-gray-50" data-testid="process-steps-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Kaip vyksta bendradarbiavimas?
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Paprastas ir skaidrus procesas nuo pirmo kontakto iki nuolatinio bendradarbiavimo
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {steps.map((step, index) => {
            const Icon = step.icon;
            return (
              <div
                key={index}
                className="relative"
                data-testid={`process-step-${index}`}
              >
                {/* Connector line for desktop */}
                {index < steps.length - 1 && (
                  <div className="hidden lg:block absolute top-12 left-1/2 w-full h-0.5 bg-blue-200 z-0"></div>
                )}
                
                <div className="relative bg-white rounded-xl shadow-md p-6 text-center hover:shadow-xl transition-shadow z-10">
                  <div className="relative inline-flex items-center justify-center mb-4">
                    <div className="absolute inset-0 bg-blue-100 rounded-full"></div>
                    <div className="relative bg-blue-600 p-4 rounded-full">
                      <Icon className="h-8 w-8 text-white" />
                    </div>
                    <div className="absolute -top-2 -right-2 bg-blue-600 text-white w-8 h-8 rounded-full flex items-center justify-center font-bold text-sm">
                      {step.step}
                    </div>
                  </div>
                  <h3 className="text-lg font-bold text-gray-900 mb-2">{step.title}</h3>
                  <p className="text-gray-600 text-sm">{step.description}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ProcessSteps;